import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { FormControl } from '@angular/forms';
import { MyBranchService } from '../../my-branch.service';

@Component({
  selector: 'app-moving-fs',
  templateUrl: './moving-fs.component.html',
  styleUrls: ['./moving-fs.component.scss']
})
export class MovingFsComponent implements OnInit {

  shiftControl = new FormControl();
  fullName = localStorage.getItem('userFullName');
  shiftsForSupervisor = [];
  sites = [];
  shiftsForSupervisorReturned = false;
  sitesReturned = false;
  loading = true;
  sel = localStorage.getItem('selectedBranchCode') ? localStorage.getItem('selectedBranchCode') : localStorage.getItem('branch1');

  constructor(
    public dialogRef: MatDialogRef<MovingFsComponent>,
    @Inject(MAT_DIALOG_DATA) public info: any,
    public dialog: MatDialog,
    public myBranchService: MyBranchService,
  ) {

  }

  //fetch all the shifts for the supervisor and all the active sites
  ngOnInit() {
    this.myBranchService.getShiftsForSupervisor(this.info.supervisor.inspectorId).subscribe((data) => {
      this.shiftsForSupervisor = data;
      this.shiftsForSupervisorReturned = true;
      this.compileFieldSupervisorShifts();
    });

    this.myBranchService.getSites().subscribe((data) => {
      //function that groups the sites by their branch as a key and sorts them alphebatically
      const groupByKey = (list, key) => list.reduce((hash, obj) => ({...hash, [obj[key]]:( hash[obj[key]] || [] ).concat(obj)}), {});
      const selectedBranchName = localStorage.getItem('selectedBranchName');
      const tempSites = groupByKey(data, 'name');

      if (selectedBranchName === 'All') {
        this.sites = Object.values(tempSites);
      } else {
        const selectedBranchSites = tempSites[selectedBranchName];
        delete tempSites[selectedBranchName];
        this.sites = [selectedBranchSites, ...Object.values(tempSites)];
      }
      this.sitesReturned = true;
      this.compileFieldSupervisorShifts();
    });
  }

  compileFieldSupervisorShifts() {
    if (this.shiftsForSupervisorReturned && this.sitesReturned) {
      this.loading = false;

      //loop through all sites by branch and assign the dropdown of each site a shift if the supervisor has been assigned a shift to that branch
      for (const branch in this.sites) {
        for (var i=0; i<this.sites[branch].length; i++) {
          let tempSite = this.sites[branch][i];
          tempSite.shiftControlList = [];

          //shiftList are the shift types for that site
          tempSite.shiftList = [];
          tempSite.c1label !=="" ? tempSite.shiftList.push(tempSite.c1label) : null;
          tempSite.c2label !=="" ? tempSite.shiftList.push(tempSite.c2label) : null;
          tempSite.c3label !=="" ? tempSite.shiftList.push(tempSite.c3label) : null;
          tempSite.c4label !=="" ? tempSite.shiftList.push(tempSite.c4label) : null;
          tempSite.c5label !=="" ? tempSite.shiftList.push(tempSite.c5label) : null;
          tempSite.c6label !=="" ? tempSite.shiftList.push(tempSite.c6label) : null;

          for (var j=0; j<this.shiftsForSupervisor.length; j++) {
            if (tempSite.customerId === this.shiftsForSupervisor[j].site) {
              tempSite.shiftControlList.push(this.shiftsForSupervisor[j].shift);
            }
          }

          //select the dropdown shifts if has assigned shifts, else leave the shifts unselected
          if (tempSite.shiftControlList.length > 0) {
            tempSite.shiftControl = new FormControl(tempSite.shiftControlList);
          } else {
            tempSite.shiftControl = new FormControl();
          }

          //whenever a site dropdown is changed, remove or add a shift for that site
          tempSite.shiftControl.valueChanges.subscribe((shifts) => {
            tempSite.selectedShifts = shifts;
            let shiftToAdd = [];
            let shiftToRemove = [];

            if (tempSite.selectedShifts.length>0) {
              for (let j=0; j<tempSite.selectedShifts.length; j++) {
                let shift = tempSite.selectedShifts[j];
                if (tempSite.shiftControlList && !tempSite.shiftControlList.includes(shift)) {
                  shiftToAdd.push(shift);
                }
              }
            }

            if (tempSite.shiftControlList.length>0) {
              for (let j=0; j<tempSite.shiftControlList.length; j++) {
                let shift = tempSite.shiftControlList[j];
                if (tempSite.selectedShifts && !tempSite.selectedShifts.includes(shift)) {
                  shiftToRemove.push(shift);
                }
              }
            }

            if (shiftToAdd.length>0) {
              this.myBranchService.setShiftsForSupervisor(this.fullName, this.info.supervisor.inspectorId, tempSite.customerId, shiftToAdd[0]).subscribe(()=>{
                tempSite.shiftControlList.push(shiftToAdd[0])
              });
            }
            if (shiftToRemove.length>0) {
              this.myBranchService.removeShiftsForSupervisor(this.fullName, this.info.supervisor.inspectorId, tempSite.customerId, shiftToRemove[0]).subscribe(()=>{
                tempSite.shiftControlList.splice(tempSite.shiftControlList.indexOf(shiftToRemove[0]), 1);
              });
            }
          });
          this.sites[branch][i] = tempSite;
        }
      }
    }
  }

  closeDialog() {
    this.dialogRef.close({event:'Close'});
  }
}
